import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-md-6 mx-auto" }
const _hoisted_2 = { class: "dl-horizontal" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("dt", null, "ID", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("dt", null, "Name", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("dt", null, "Package Id", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("dt", null, "Price", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("dt", null, "Amount", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("dt", null, "Display rate", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("dt", null, "Required game", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("dt", null, "Duration seconds", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("dt", null, "Is enabled", -1)
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("dt", null, "Is default", -1)
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("dt", null, "Image", -1)
const _hoisted_16 = { class: "card-footer bg-white border border-light" }
const _hoisted_17 = { class: "col text-center" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h5", null, "Add reward", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_20 = { class: "form-horizontal" }
const _hoisted_21 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_image_holder = _resolveComponent("app-image-holder")!
  const _component_app_table = _resolveComponent("app-table")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_select = _resolveComponent("app-select")!
  const _component_app_form_row = _resolveComponent("app-form-row")!
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_modal = _resolveComponent("app-modal")!
  const _component_app_card = _resolveComponent("app-card")!

  return (_openBlock(), _createBlock(_component_app_card, {
    class: "col-lg-8 mx-auto",
    label: "Starter Pack Detail"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("dl", _hoisted_2, [
          _createElementVNode("tr", null, [
            _hoisted_3,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.id), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_4,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.name), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_5,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.packageId), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_6,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.price), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_7,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.amount), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_8,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.displayRate), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_9,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.gameRequired), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_10,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.durationSeconds), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_11,
            _createElementVNode("dd", {
              innerHTML: _ctx.renderBoolean(_ctx.model.isEnabled)
            }, null, 8, _hoisted_12)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_13,
            _createElementVNode("dd", {
              innerHTML: _ctx.renderBoolean(_ctx.model.isDefault)
            }, null, 8, _hoisted_14)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_15,
            _createElementVNode("dd", null, [
              _createVNode(_component_app_image_holder, {
                image: _ctx.model.image,
                status: _ctx.model.imageStatus
              }, null, 8, ["image", "status"])
            ])
          ])
        ])
      ]),
      _createVNode(_component_app_table, {
        columns: _ctx.table.columns,
        rows: _ctx.rewardDetailtList,
        total: _ctx.rewardDetailtList.length,
        actions: _ctx.table.actions
      }, null, 8, ["columns", "rows", "total", "actions"]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          (_ctx.model.canEdit)
            ? (_openBlock(), _createBlock(_component_app_button, {
                key: 0,
                name: "Add reward",
                theme: "info",
                icon: "fa-gift",
                onClick: _withModifiers(_ctx.rewardCreationModal.rewardActions.openModal, ["prevent"])
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.model.canEnable)
            ? (_openBlock(), _createBlock(_component_app_button, {
                key: 1,
                name: "Enable",
                theme: "success",
                icon: "fa-play",
                onClick: _withModifiers(_ctx.actions.enable, ["prevent"])
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.model.canDisable)
            ? (_openBlock(), _createBlock(_component_app_button, {
                key: 2,
                name: "Disable",
                theme: "warning",
                icon: "fa-stop",
                onClick: _withModifiers(_ctx.actions.disable, ["prevent"])
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_component_app_button, {
            name: "Delete",
            theme: "danger",
            icon: "fa-trash-alt",
            disabled: !_ctx.model.canDelete,
            onClick: _withModifiers(_ctx.actions.remove, ["prevent"])
          }, null, 8, ["disabled", "onClick"])
        ])
      ]),
      _createVNode(_component_app_modal, {
        name: _ctx.rewardCreationModal.MODAL_NAME
      }, {
        default: _withCtx(() => [
          _hoisted_18,
          _hoisted_19,
          _createElementVNode("form", _hoisted_20, [
            _createVNode(_component_app_form_row, { label: "Type" }, {
              default: _withCtx(() => [
                _createVNode(_component_app_select, {
                  options: _ctx.StarterPackRewardOptions,
                  modelValue: _ctx.rewardCreationModal.model.type,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.rewardCreationModal.model.type) = $event)),
                  modelModifiers: { number: true },
                  validations: _ctx.rewardCreationModal.v$.value.type
                }, null, 8, ["options", "modelValue", "validations"])
              ]),
              _: 1
            }),
            (_ctx.rewardCreationModal.model.type !== _ctx.StarterPackRewardType.NoAds)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (!_ctx.rewardCreationModal.model.canEditData)
                    ? (_openBlock(), _createBlock(_component_app_form_row, {
                        key: 0,
                        label: "Item name"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_app_select, {
                            options: _ctx.rewardCreationModal.rewardOptions.value,
                            modelValue: _ctx.rewardCreationModal.model.data,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.rewardCreationModal.model.data) = $event)),
                            modelModifiers: { number: true },
                            validations: _ctx.rewardCreationModal.v$.value.data
                          }, null, 8, ["options", "modelValue", "validations"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_app_form_row, {
                    label: _ctx.rewardCreationModal.model.dataLabel
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_app_input, {
                        type: "number",
                        modelValue: _ctx.rewardCreationModal.model.data,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rewardCreationModal.model.data) = $event)),
                        modelModifiers: { number: true },
                        disabled: !_ctx.rewardCreationModal.model.canEditData
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.rewardCreationModal.model.type === _ctx.StarterPackRewardType.NoAds)
              ? (_openBlock(), _createBlock(_component_app_form_row, {
                  key: 1,
                  label: "Month"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_app_input, {
                      type: "number",
                      modelValue: _ctx.rewardCreationModal.model.quantity,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.rewardCreationModal.model.quantity) = $event)),
                      modelModifiers: { number: true },
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_app_form_row, {
                  key: 2,
                  label: _ctx.rewardCreationModal.model.quantityLabel
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_app_input, {
                      type: "number",
                      modelValue: _ctx.rewardCreationModal.model.quantity,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.rewardCreationModal.model.quantity) = $event)),
                      modelModifiers: { number: true },
                      validations: _ctx.rewardCreationModal.v$.value.quantity,
                      disabled: !_ctx.rewardCreationModal.model.canEditQuantity
                    }, null, 8, ["modelValue", "validations", "disabled"])
                  ]),
                  _: 1
                }, 8, ["label"]))
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_app_button, {
              name: "Create",
              theme: "info",
              onClick: _withModifiers(_ctx.actions.createReward, ["prevent"])
            }, null, 8, ["onClick"]),
            _createVNode(_component_app_button, {
              name: "Cancel",
              theme: "secondary",
              onClick: _withModifiers(_ctx.rewardCreationModal.rewardActions.closeModal, ["prevent"])
            }, null, 8, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["name"])
    ]),
    _: 1
  }))
}